/*
 * Watch party events — content-managed data block.
 * Add new events here. The /watch-party/[slug] page reads from this.
 */
export const WATCH_PARTY_EVENTS = {
  'bulbbul-six-years': {
    slug: 'bulbbul-six-years',
    title: 'Bulbbul, six years on',
    subtitle: 'A watch party',
    scheduledAt: '2026-06-24T15:30:00Z', // 9:00 PM IST
    durationMinutes: 94,
    watchUrl: 'https://www.netflix.com/title/81029046',
    watchPlatform: 'Netflix',
    description: 'Watch Bulbbul on Netflix. We meet here at 9 PM IST sharp. The film is more frightening, more tender, more itself, six years later.',
    contextLine: 'Watch Bulbbul on Netflix. We meet here at 9 PM IST sharp.',
  },
};

export const ADMIN_EMAILS = ['tiwary.avi@gmail.com'];
